export const bloodTypeOptions = [
"A+",
"A-",
"B+",
"B-",
"AB+",
"AB-",
"O+",
"O-"
];